<!-- 라이브인포 등록 폼 -->
<template>
  <div>
    <b-card v-if="contentType == 1 || contentType == 2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start"
        >
          <feather-icon
             icon="HeartIcon"
            size="19"
          />
          <h4
            class="mb-0 ml-50"
            style="min-width: 120px"
          >
            컨텐츠 유형
          </h4>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-end"
        >
          <b-button
            variant="outline-secondary"
            class="ml-1"
            @click.prevent="resetInterestContent()"
          >
            <feather-icon
              icon="Trash2Icon"
              class="mr-50"
            />
            <span>초기화</span>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-1">
          <b-col
            cols="6"
            md="6"
          >
            <b-form-group
              label="컨텐츠 유형"
              label-for="liveinfo-interest-content"
            >
              <b-form-input
                id="liveinfo-interest-content"
                :value="liveinfo.interestContentTitles || ''"
                readonly
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
            md="6"
            class="d-flex align-items-center justify-content-start mt-50"
          >
            <b-button
              variant="outline-primary"
              @click.prevent="showInterestContentSelect = true"
            >
              <feather-icon
                icon="SearchIcon"
                class="mr-50"
              />
              <span>유형 선택</span>
            </b-button>
          </b-col>
        </b-row>
    </b-card>
    <validation-observer ref="liveinfoFormRules">
      <b-card>
        <b-row>
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-start"
          >
            <feather-icon
              icon="CalendarIcon"
              size="19"
            />
            <h4 class="mb-0 ml-50">
              게시기간
            </h4>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="게시기간(Fr)"
              label-for="liveinfo-start-date"
            >
              <validation-provider
                #default="{ errors }"
                name="게시기간(Fr)"
                :rules="{
                  required: true,
                  before: liveinfo.endDate,
                }"
              >
                <b-form-datepicker
                  id="liveinfo-start-date"
                  v-model="liveinfo.startDate"
                  placeholder="게시기간(Fr)"
                  :state="errors.length > 0 ? false : null"
                  v-bind="contentType === 3 ? {
                    'date-disabled-fn': (ymd) => dateDisabled(ymd, null),
                    readonly: liveinfoId !== null && liveinfo.startDate !== null && dateDisabled(liveinfo.startDate, null, true),
                    style: getInputGroupStyle('', liveinfoId !== null && liveinfo.startDate !== null && dateDisabled(liveinfo.startDate, null, true)),
                    disabled: liveinfoId !== null && liveinfo.startDate !== null && dateDisabled(liveinfo.startDate, null, true)
                  } : {}"
                  />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="게시기간(To)"
              label-for="liveinfo-end-date"
            >
              <validation-provider
                #default="{ errors }"
                name="게시기간(To)"
                :rules="{
                  required: true,
                  after: liveinfo.startDate,
                }"
              >
                <b-form-datepicker
                  id="liveinfo-end-date"
                  v-model="liveinfo.endDate"
                  placeholder="게시기간(To)"
                  :state="errors.length > 0 ? false : null"
                  v-bind="contentType === 3 ? {
                    'date-disabled-fn': (ymd) => dateDisabled(ymd, originalLiveInfoEndDate),
                    readonly: liveinfoId !== null && liveinfo.endDate !== null && dateDisabled(originalLiveInfoEndDate, null, false),
                    style: getInputGroupStyle('', liveinfoId !== null && liveinfo.endDate !== null && dateDisabled(originalLiveInfoEndDate, null, false)),
                    disabled: liveinfoId !== null && liveinfo.endDate !== null && dateDisabled(originalLiveInfoEndDate, null, false)
                  } : {}"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <validation-observer ref="condSetTypeFormRules">
          <b-row>
            <b-col
              class="d-flex align-items-center justify-content-start"
            >
              <feather-icon
                icon="UserCheckIcon"
                size="19"
              />
              <h4
                class="mb-0 ml-50"
              >
                {{ getCodeLabel('contentName', contentType) }} 노출 조건
              </h4>
              <ViewListBadge
                :content-type="contentType"
                :condition-type="10"
                :show-guide="true"
              />
            </b-col>
          </b-row>
          <b-row class="mt-1">

            <b-col
              cols="12"
              md="6"
            >
              <b-form-group>
                <label for="cond-set-type">노출 대상</label>

                <b-form-radio-group
                  v-model="liveinfo.condSetType"
                  name="condSetType"
                  :disabled="isStarted"
                >
                  <b-form-radio
                    class="custom-control-primary"
                    value="11"
                    @change="changeCondSetType"
                  >
                    진료과/지역별 사용자
                  </b-form-radio>
                  <!-- 간편처방등록(contentType 8)은 타겟그룹 미사용, 진료과/지역별 사용자로 고정 -->
                  <b-form-radio
                    v-if="contentType != 8"
                    class="custom-control-secondary"
                    value="21"
                    @change="changeCondSetType"
                  >
                    타겟그룹
                  </b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col v-if="contentType == 1">
              <b-row v-if="contentType == 1">
                <b-col cols="12">
                  <label>세팅 정보로 닥터인포에 노출하기</label>
                  <ViewListBadge
                    :content-type="contentType"
                    :condition-type="901"
                    :show-guide="true"
                  />
                </b-col>
                <b-col
                  cols="12"
                >
                  <b-form-group>
                    <b-form-radio-group 
                      v-model="liveinfo.isCondDeptDrInfo" 
                      :disabled="isStarted"
                    >
                      <b-form-radio
                        class="custom-control-primary"
                        value="true"
                      >
                        사용
                      </b-form-radio>
                      <b-form-radio
                        class="custom-control-secondary"
                        value="false"
                      >
                        사용안함
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

          </b-row>

          <b-row
            v-if="liveinfo.condSetType == 11"
            class="mt-1"
          >
            <b-col cols="10">
              <b-form-group>
                <label for="liveinfo-cond-dept">진료과</label>
                <!-- <ViewListBadge
                  :content-type="contentType"
                  :condition-type="1"
                  :show-guide="true"
                /> -->
                <validation-provider
                  #default="{ errors }"
                  name="진료과"
                  rules="required"
                >
                  <b-form-input
                    id="liveinfo-cond-dept"
                    v-model="liveinfo.condDeptNames"
                    readonly
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="2"
              class="mb-50"
            >
              <b-button
                variant="outline-primary"
                class="mt-0 mt-md-2"
                @click.prevent="showMediDeptSelect = true"
              >
                <feather-icon
                  icon="PlusSquareIcon"
                  class="mr-50"
                />
                <span>진료과 선택</span>
              </b-button>
            </b-col>
          </b-row>

          <!-- <b-row>
          <b-col cols="10">
            <b-form-group>
              <label for="liveinfo-cond-major">전공과</label>
              <validation-provider
                #default="{ errors }"
                name="전공과"
                rules="required"
              >
                <b-form-input
                  id="liveinfo-cond-major"
                  v-model="liveinfo.condMajorNames"
                  readonly
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="2"
            class="mb-50"
          >
            <b-button
              variant="outline-primary"
              class="mt-0 mt-md-2"
              @click.prevent="showMajorSelect = true"
            >
              <feather-icon
                icon="PlusSquareIcon"
                class="mr-50"
              />
              <span>목록</span>
            </b-button>
          </b-col>
        </b-row> -->
          <b-row
            v-if="liveinfo.condSetType == 11"
          >
            <b-col cols="10">
              <b-form-group>
                <label for="liveinfo-cond-region">지역</label>
                <!-- <ViewListBadge
                  :content-type="contentType"
                  :condition-type="2"
                  :show-guide="true"
                /> -->
                <validation-provider
                  #default="{ errors }"
                  name="지역"
                  rules="required"
                >
                  <b-form-input
                    id="liveinfo-cond-region"
                    v-model="liveinfo.condRegionNames"
                    readonly
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="2"
              class="mb-50"
            >
              <b-button
                variant="outline-primary"
                class="mt-0 mt-md-2"
                @click.prevent="showRegionSelect = true"
              >
                <feather-icon
                  icon="PlusSquareIcon"
                  class="mr-50"
                />
                <span>지역 선택</span>
              </b-button>
            </b-col>
          </b-row>
          <b-row
            v-if="liveinfo.condSetType == 21"
            class="mt-1"
          >
            <b-col
              cols="10"
              md="5"
            >
              <b-form-group
                :disabled="isStarted"
              >
                <label for="liveinfo-cond-targetgroup">타겟그룹</label>
                <!-- <ViewListBadge
                  :content-type="contentType"
                  :condition-type="4"
                  :show-guide="true"
                /> -->
                <validation-provider
                  #default="{ errors, validate }"
                  name="타겟그룹"
                  rules="required"
                >
                  <b-form-input
                    id="liveinfo-cond-targetgroup"
                    :value="liveinfo.targetGroupId ? `[${liveinfo.targetGroupId}] ${liveinfo.targetGroupTitle}` : ''"
                    readonly
                    :state="errors.length > 0 ? false : null"
                    @input="validate"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="4"
              class="mb-50"
            >
              <b-button
                variant="outline-primary"
                class="mt-0 mt-md-2"
                :disabled="isStarted"
                @click.prevent="showTargetGroupSelect = true"
              >
                <feather-icon
                  icon="SearchIcon"
                  class="mr-50"
                />
                <span>타겟그룹 선택</span>
              </b-button>
              <b-button
                v-if="liveinfo.targetGroupId"
                variant="outline-danger"
                class="ml-1 mt-0 mt-md-2"
                :disabled="isStarted"
                @click.prevent="liveinfo.targetGroupId = null; liveinfo.targetGroupTitle = null;"
              >
                <feather-icon
                  icon="Trash2Icon"
                  class="mr-50"
                />
                <span>타겟그룹 제거</span>
              </b-button>
            </b-col>

          </b-row>
        </validation-observer>
      </b-card>
    </validation-observer>
    <!-- 메디컬트랜드/간편처방등록은 메인 설정 제외 -->
    <b-card v-if="contentType != 2 && contentType != 8">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start"
        >
          <feather-icon
            icon="GridIcon"
            size="19"
          />
          <h4
            class="mb-0 ml-50"
            style="min-width: 150px"
          >
            메인 노출
          </h4>
          <b-form-checkbox
            v-model="liveinfo.isMainView"
            switch
            inline
            class="custom-control-info"
            style="min-width: 120px"
          >
            {{ liveinfo.isMainView ? '사용' : '사용안함' }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <validation-observer ref="liveinfoMainRules">
        <b-row
          v-show="liveinfo.isMainView"
          class="mt-1"
        >
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="게시기간(Fr)"
              label-for="liveinfo-main-start-date"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                name="게시기간(Fr)"
                :rules="{
                  required: true,
                  before: liveinfo.mainEndDate,
                  dateBetween: [liveinfo.startDate, liveinfo.endDate],
                }"
              >
                <b-form-datepicker
                  id="liveinfo-main-start-date"
                  v-model="liveinfo.mainStartDate"
                  placeholder="게시기간(Fr)"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">
                  {{
                    failedRules.hasOwnProperty('dateBetween')
                      ? '메인 노출 기간은 게시기간 이내로 제한됩니다.'
                      : errors[0]
                  }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="게시기간(To)"
              label-for="liveinfo-main-end-date"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                name="게시기간(To)"
                :rules="{
                  required: true,
                  after: liveinfo.mainStartDate,
                  dateBetween: [liveinfo.startDate, liveinfo.endDate],
                }"
              >
                <b-form-datepicker
                  id="liveinfo-main-end-date"
                  v-model="liveinfo.mainEndDate"
                  placeholder="게시기간(To)"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">
                  {{
                    failedRules.hasOwnProperty('dateBetween')
                      ? '메인 노출 기간은 게시기간 이내로 제한됩니다.'
                      : errors[0]
                  }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
          v-show="liveinfo.isMainView"
          class="mt-1"
        >
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              label="상단 고정 (메인 노출 게시 기간 종료일을 오늘 또는 이후 날짜로 설정해야 사용할 수 있습니다.)"
              label-for="liveinfo-is-main-top-fix"
            >
              <b-form-radio-group
                v-model="liveinfo.isMainTopFix"
                :disabled="liveinfo.mainEndDate ? (liveinfo.mainEndDate < dayjs().format('YYYY-MM-DD')) : true"
                >
                <b-form-radio
                  class="custom-control-primary"
                  :value="true"
                >
                  사용
                </b-form-radio>
                <b-form-radio
                  class="custom-control-secondary"
                  :value="false"
                >
                  사용안함
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
             <b-button
                variant="outline-primary"
                :disabled="!liveinfo.isMainTopFix"
                @click.prevent="isMainTopFixed ? (showMainTopFixManage = true) :  (showMainTopFixManageGuide = true)"
              >
                <span>우선순위 설정</span>
              </b-button>
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
             <small
               v-if="showMainTopFixManageGuide"
               class="text-danger"
              >
              상단 고정을 ‘사용’으로 선택하고 컨텐츠를 저장한 후에 우선순위 설정이 가능합니다.
              </small>
          </b-col>
        </b-row>
      </validation-observer>
    </b-card>
    <!-- 라이브DI는 약품정보에서만 사용 -->
    <b-card v-show="contentType == 1">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start"
        >
          <feather-icon
            icon="RefreshCwIcon"
            size="19"
          />
          <h4
            class="mb-0 ml-50"
            style="min-width: 150px"
          >
            라이브 DI
          </h4>
          <b-form-checkbox
            v-model="liveinfo.isLiveDi"
            switch
            inline
            class="custom-control-info"
            style="min-width: 120px"
          >
            {{ liveinfo.isLiveDi ? '사용' : '사용안함' }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <validation-observer ref="liveinfoIsLiveDiRules">
        <b-row
          v-if="liveinfo.isLiveDi"
          class="mt-1"
        >
          <b-col>
            <b-form-group
              label="노출 메시지"
              label-for="liveinfo-livedi-title"
            >
              <validation-provider
                #default="{ errors }"
                name="노출 메시지"
                rules="required"
              >
                <b-form-input
                  id="liveinfo-livedi-title"
                  v-model="liveinfo.liveDiTitle"
                  placeholder="입력하세요"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- 라이브DI 구간설정 START -->
        <b-row
          v-if="liveinfo.isLiveDi"
          class="mt-1"
        >
          <b-col>
            <b-form-group>
              <label for="liveinfo-livedi-title">노출 기간</label>
              <label class="ml-50 text-secondary"> (게시기간 : </label>
              <label class="ml-50 text-primary">{{ `${!(liveinfo.startDate) ? '미지정' : liveinfo.startDate}` }}</label>
              <label class="ml-50 text-secondary">~</label>
              <label class="ml-50 text-primary">{{ ` ${!(liveinfo.endDate) ? '미지정' : liveinfo.endDate}` }}</label>
              <label class="text-secondary">) </label>
              <b-row>
                <b-col md="3">
                  <validation-provider
                    #default="{ errors, failedRules }"
                    name="노출기간(Fr)"
                    :rules="{
                      required: true,
                      dateBetween: [liveinfo.startDate, liveinfo.endDate],
                      dateBefore: liveinfo.liveDiEndDate,
                    }"
                  >
                    <b-form-datepicker
                      id="liveinfo-livedi-start-date"
                      v-model="liveinfo.liveDiStartDate"
                      size="md"
                      placeholder="노출기간(Fr)"
                      :readonly="(liveinfo.liveDiStartDate !== null) && dateDisabled(liveinfo.liveDiStartDate, null)"
                      :state="errors.length > 0 ? false : null"
                      :date-disabled-fn="(ymd) => dateDisabled(ymd, null)"
                      :style="getInputGroupStyle('', (liveinfo.liveDiStartDate !== null) && dateDisabled(liveinfo.liveDiStartDate, null))"
                      :disabled="(liveinfo.liveDiStartDate !== null) && dateDisabled(liveinfo.liveDiStartDate, null)"
                    />
                    <small class="text-danger">
                      {{
                        failedRules.hasOwnProperty('required')
                          ? '필수 입력값입니다.'
                          : failedRules.hasOwnProperty('dateBetween')
                            ? '게시기간 내로 입력해주세요.'
                            : failedRules.hasOwnProperty('dateBefore')
                              ? '종료일보다 늦을 수 없습니다.'
                              : errors[0]
                      }}
                    </small>
                  </validation-provider>
                </b-col>
                ~
                <b-col md="3">
                  <validation-provider
                    #default="{ errors, failedRules }"
                    name="노출기간(To)"
                    :rules="{
                      required: true,
                      dateBetween: [liveinfo.startDate, liveinfo.endDate],
                      dateAfter: (liveinfo.liveDiStartDate > originalLiveDiEndDate) ? liveinfo.liveDiStartDate : originalLiveDiEndDate,
                    }"
                  >
                    <b-form-datepicker
                      id="liveinfo-livedi-end-date"
                      v-model="liveinfo.liveDiEndDate"
                      size="md"
                      placeholder="노출기간(To)"
                      :readonly="(liveinfo.liveDiEndDate !== null) && dateDisabled(liveDiEndDateNextDay, null)"
                      :state="errors.length > 0 ? false : null"
                      :date-disabled-fn="(ymd) => dateDisabled(ymd, originalLiveDiEndDate)"
                      :style="getInputGroupStyle('', (liveinfo.liveDiEndDate !== null) && dateDisabled(liveDiEndDateNextDay, null))"
                      :disabled="(liveinfo.liveDiEndDate !== null) && dateDisabled(liveDiEndDateNextDay, null)"
                    />
                    <small class="text-danger">
                      {{
                        failedRules.hasOwnProperty('required')
                          ? '필수 입력값입니다.'
                          : failedRules.hasOwnProperty('dateBetween')
                            ? '게시기간 내로 입력해주세요.'
                            : failedRules.hasOwnProperty('dateAfter')
                              ? '시작일 또는 기설정 종료일보다 빠를 수 없습니다.'
                              : errors[0]
                      }}
                    </small>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- 라이브DI 구간설정 END -->

        <b-row
          v-if="liveinfo.isLiveDi"
          class="mt-1"
        >
          <b-col
            cols="12"
            class="mt-1"
          >
            <b-form-group
              label="라이브DI 교차조건"
              label-for="liveinfo-is-livedi-or"
            >
              <b-form-radio-group
                id="liveinfo-is-livedi-or"
                v-model="liveinfo.isLiveDiOr"
                :options="constCodes.conditionOr"
                value-field="code"
                text-field="label"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <small class="text-muted">※ 같은 칸 안의 코드는 쉼표(,)로 구분(OR), 칸을 추가하면 칸 사이는 AND 로 비교됩니다.</small>
          </b-col>
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="청구코드"
              :rules="{
                requiredIf: !liveDiCondDiseaseCodesModel && !liveDiCondLabCodesModel,
              }"
            >
              <b-form-group
                label="청구코드 (같은 칸 = OR / 칸 추가 = AND)"
                label-for="liveinfo-livedi-drug-codes"
              >
                <b-form-input
                  v-model="liveDiCondDrugCodesModel"
                  class="d-none"
                />
                <div
                  v-for="(group, gIdx) in liveinfo.liveDiCondDrugCodeGroups"
                  :key="`livedi-drug-${gIdx}`"
                  class="d-flex align-items-center"
                  :class="{ 'mt-25': gIdx !== 0 }"
                >
                  <b-form-input
                    v-model="group.code"
                    placeholder="코드를 입력하세요 (쉼표 구분 시 OR)"
                    :state="errors.length > 0 ? false : null"
                  />
                  <b-button
                    v-if="liveinfo.liveDiCondDrugCodeGroups.length > 1"
                    variant="outline-danger"
                    size="sm"
                    class="ml-1"
                    @click="removeCodeGroup(liveinfo.liveDiCondDrugCodeGroups, gIdx)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                  <b-button
                    v-if="gIdx === liveinfo.liveDiCondDrugCodeGroups.length - 1"
                    variant="outline-primary"
                    size="sm"
                    class="ml-1"
                    @click="addCodeGroup(liveinfo.liveDiCondDrugCodeGroups)"
                  >
                    <feather-icon icon="PlusIcon" />
                  </b-button>
                </div>
                <small class="text-danger">
                  {{
                    errors.length > 0
                      ? '라이브 DI 사용시, 조건은 한가지 이상 반드시 입력되어야 합니다.'
                      : ''
                  }}
                </small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="질병코드"
              :rules="{
                requiredIf: !liveDiCondDrugCodesModel && !liveDiCondLabCodesModel,
              }"
            >
              <b-form-group
                label="질병코드 (같은 칸 = OR / 칸 추가 = AND)"
                label-for="liveinfo-livedi-disease-codes"
              >
                <b-form-input
                  v-model="liveDiCondDiseaseCodesModel"
                  class="d-none"
                />
                <div
                  v-for="(group, gIdx) in liveinfo.liveDiCondDiseaseCodeGroups"
                  :key="`livedi-disease-${gIdx}`"
                  class="d-flex align-items-center"
                  :class="{ 'mt-25': gIdx !== 0 }"
                >
                  <b-form-input
                    v-model="group.code"
                    placeholder="코드를 입력하세요 (쉼표 구분 시 OR)"
                    :state="errors.length > 0 ? false : null"
                  />
                  <b-button
                    v-if="liveinfo.liveDiCondDiseaseCodeGroups.length > 1"
                    variant="outline-danger"
                    size="sm"
                    class="ml-1"
                    @click="removeCodeGroup(liveinfo.liveDiCondDiseaseCodeGroups, gIdx)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                  <b-button
                    v-if="gIdx === liveinfo.liveDiCondDiseaseCodeGroups.length - 1"
                    variant="outline-primary"
                    size="sm"
                    class="ml-1"
                    @click="addCodeGroup(liveinfo.liveDiCondDiseaseCodeGroups)"
                  >
                    <feather-icon icon="PlusIcon" />
                  </b-button>
                </div>
                <small class="text-danger">
                  {{
                    errors.length > 0
                      ? '라이브 DI 사용시, 조건은 한가지 이상 반드시 입력되어야 합니다.'
                      : ''
                  }}
                </small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="검사코드"
              :rules="{
                requiredIf: !liveDiCondDrugCodesModel && !liveDiCondDiseaseCodesModel,
              }"
            >
              <b-form-group
                label="검사코드 (같은 칸 = OR / 칸 추가 = AND ※ 검사는 원코드 5자리로 입력. e.g. 'D2280000'[X] 'D2280'[O])"
                label-for="liveinfo-livedi-lab-codes"
              >
                <b-form-input
                  v-model="liveDiCondLabCodesModel"
                  class="d-none"
                />
                <div
                  v-for="(group, gIdx) in liveinfo.liveDiCondLabCodeGroups"
                  :key="`livedi-lab-${gIdx}`"
                  class="d-flex align-items-center"
                  :class="{ 'mt-25': gIdx !== 0 }"
                >
                  <b-form-input
                    v-model="group.code"
                    placeholder="코드를 입력하세요 (쉼표 구분 시 OR)"
                    :state="errors.length > 0 ? false : null"
                  />
                  <b-button
                    v-if="liveinfo.liveDiCondLabCodeGroups.length > 1"
                    variant="outline-danger"
                    size="sm"
                    class="ml-1"
                    @click="removeCodeGroup(liveinfo.liveDiCondLabCodeGroups, gIdx)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                  <b-button
                    v-if="gIdx === liveinfo.liveDiCondLabCodeGroups.length - 1"
                    variant="outline-primary"
                    size="sm"
                    class="ml-1"
                    @click="addCodeGroup(liveinfo.liveDiCondLabCodeGroups)"
                  >
                    <feather-icon icon="PlusIcon" />
                  </b-button>
                </div>
                <small class="text-danger">
                  {{
                    errors.length > 0
                      ? '라이브 DI 사용시, 조건은 한가지 이상 반드시 입력되어야 합니다.'
                      : ''
                  }}
                </small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </validation-observer>
    </b-card>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start"
        >
          <feather-icon
            icon="BellIcon"
            size="19"
          />
          <h4
            class="mb-0 ml-50"
            style="min-width: 150px"
          >
            처방 팝업
          </h4>
          <b-form-checkbox
            v-model="liveinfo.isInfoPopUp"
            switch
            inline
            class="custom-control-info"
            style="min-width: 120px"
          >
            {{ liveinfo.isInfoPopUp ? '사용' : '사용안함' }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <validation-observer ref="liveinfoIsInfoPopRules">
        <b-row
          v-if="liveinfo.isInfoPopUp"
          class="mt-1"
        >
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="알림기간(Fr)"
              label-for="liveinfo-ipu-start-date"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                name="알림기간(Fr)"
                :rules="{
                  required: true,
                  before: liveinfo.ipuEndDate,
                  dateBetween: [liveinfo.startDate, liveinfo.endDate],
                }"
              >
                <b-form-datepicker
                  id="liveinfo-ipu-start-date"
                  v-model="liveinfo.ipuStartDate"
                  placeholder="알림기간(Fr)"
                  :state="errors.length > 0 ? false : null"
                  @change="spuOneTimeChange()"
                />
                <small class="text-danger">
                  {{
                    failedRules.hasOwnProperty('dateBetween')
                      ? '처방 팝업 기간은 게시기간 이내로 제한됩니다.'
                      : errors[0]
                  }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="알림기간(To)"
              label-for="liveinfo-ipu-end-date"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                name="알림기간(To)"
                :rules="{
                  required: true,
                  after: liveinfo.ipuStartDate,
                  dateBetween: [liveinfo.startDate, liveinfo.endDate],
                }"
              >
                <b-form-datepicker
                  id="liveinfo-ipu-end-date"
                  v-model="liveinfo.ipuEndDate"
                  :state="errors.length > 0 ? false : null"
                  placeholder="알림기간(To))"
                />
                <small class="text-danger">
                  {{
                    failedRules.hasOwnProperty('dateBetween')
                      ? '처방 팝업 기간은 게시기간 이내로 제한됩니다.'
                      : errors[0]
                  }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          />
          <b-col
            cols="6"
            md="3"
          >
            <b-form-group
              label="처방팝업 알림 시간"
              label-for="liveinfo-is-immediate"
            >
              <b-form-radio-group
                id="liveinfo-is-immediate"
                v-model="liveinfo.isImmediate"
                :options="constCodes.immediateOr"
                value-field="code"
                text-field="label"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
            md="3"
          >
            <b-form-group
              label="알림횟수"
              label-for="liveinfo-ipu-pop-count"
            >
              <b-form-spinbutton
                id="liveinfo-ipu-pop-count"
                v-model="liveinfo.ipuPopCount"
                min="1"
                max="10"
                inline
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
            md="3"
          >
            <b-form-group
              label="알림 유지시간"
              label-for="liveinfo-ipu-delay-sec"
            >
              <validation-provider
                #default="{ errors }"
                name="알림 유지시간"
                rules="required"
              >
                <v-select
                  id="liveinfo-ipu-delay-sec"
                  v-model="liveinfo.ipuDelaySec"
                  :options="constCodes.selectTimes"
                  :reduce="(option) => option.code"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
            md="3"
          />
          <div v-if="!liveinfo.isImmediate">
            <b-col cols="12">
              <label>알림 시간 선택</label>
            </b-col>
            <b-col
              v-for="(sched, idx) in liveinfo.schedules"
              :id="`schedules${sched.id}`"
              :key="sched.id"
              cols="12"
              class="d-flex align-items-center justify-content-start"
              :class="{ 'mt-25': idx !== 0 }"
            >
              <template v-if="sched.popUpType === 1">
                <validation-provider
                  #default="{ errors }"
                  name="알림 시간 선택"
                  rules="required"
                >
                  <v-date-picker
                    v-model="sched.noticeTime"
                    type="time"
                    format="HH:mm"
                    value-type="format"
                    placeholder="HH:mm"
                    :time-picker-options="{
                      start: '08:00',
                      step: '00:05',
                      end: '20:00',
                    }"
                    class="mr-1"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <b-button
                  v-if="idx !== getSchedIdxFirstOrLast(1, true)"
                  variant="outline-danger"
                  size="sm"
                  class="mr-1"
                  @click="liveinfo.schedules.splice(idx, 1)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>삭제</span>
                </b-button>
                <b-button
                  v-if="idx === getSchedIdxFirstOrLast(1, false)"
                  variant="outline-primary"
                  size="sm"
                  @click="
                    liveinfo.schedules.push({
                      noticeTime: null,
                      popUpType: 1,
                    })
                  "
                >
                  <feather-icon
                    icon="PlusIcon"
                    class="mr-25"
                  />
                  <span>추가</span>
                </b-button>
              </template>
            </b-col>
          </div>
          <b-col
            cols="12"
            md="3"
            class="mt-1"
          >
            <b-form-group
              label="팝업 교차조건"
              label-for="liveinfo-is-info-popup-or"
            >
              <b-form-radio-group
                id="liveinfo-is-info-popup-or"
                v-model="liveinfo.isInfoPopUpOr"
                :options="constCodes.conditionOr"
                value-field="code"
                text-field="label"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="mt-1"
          >
            <b-row>
              <b-col cols="12">
                <label>환자연령</label>
                <ViewListBadge
                  :content-type="contentType"
                  :condition-type="3"
                  :show-guide="true"
                />
              </b-col>
              <b-col
                cols="12"
                lg="6"
                class="d-flex align-items-center justify-content-start"
              >
                <validation-provider
                  #default="{ errors }"
                  name="시작나이"
                  rules="required"
                >
                  <b-form-input
                    v-model="liveinfo.minAge"
                    @keyup="restrictToNumbers"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <label class="ml-50 mr-50">~</label>
                <validation-provider
                  #default="{ errors }"
                  name="끝나이"
                  rules="required"
                >
                  <b-form-input
                    v-model="liveinfo.maxAge"
                    @keyup="restrictToNumbers"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="12">
            <small class="text-muted">※ 같은 칸 안의 코드는 쉼표(,)로 구분(OR), 칸을 추가하면 칸 사이는 AND 로 비교됩니다.</small>
          </b-col>
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="청구코드"
              :rules="{
                requiredIf: !condDiseaseCodesModel && !condLabCodesModel,
              }"
            >
              <b-form-group
                label="청구코드 (같은 칸 = OR / 칸 추가 = AND)"
                label-for="liveinfo-drug-codes"
              >
                <b-form-input
                  v-model="condDrugCodesModel"
                  class="d-none"
                />
                <div
                  v-for="(group, gIdx) in liveinfo.condDrugCodeGroups"
                  :key="`drug-${gIdx}`"
                  class="d-flex align-items-center"
                  :class="{ 'mt-25': gIdx !== 0 }"
                >
                  <b-form-input
                    v-model="group.code"
                    placeholder="코드를 입력하세요 (쉼표 구분 시 OR)"
                    :state="errors.length > 0 ? false : null"
                  />
                  <b-button
                    v-if="liveinfo.condDrugCodeGroups.length > 1"
                    variant="outline-danger"
                    size="sm"
                    class="ml-1"
                    @click="removeCodeGroup(liveinfo.condDrugCodeGroups, gIdx)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                  <b-button
                    v-if="gIdx === liveinfo.condDrugCodeGroups.length - 1"
                    variant="outline-primary"
                    size="sm"
                    class="ml-1"
                    @click="addCodeGroup(liveinfo.condDrugCodeGroups)"
                  >
                    <feather-icon icon="PlusIcon" />
                  </b-button>
                </div>
                <small class="text-danger">
                  {{
                    errors.length > 0
                      ? '처방팝업 사용시, 조건은 한가지 이상 반드시 입력되어야 합니다.'
                      : ''
                  }}
                </small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="질병코드"
              :rules="{
                requiredIf: !condDrugCodesModel && !condLabCodesModel,
              }"
            >
              <b-form-group
                label="질병코드 (같은 칸 = OR / 칸 추가 = AND)"
                label-for="liveinfo-disease-codes"
              >
                <b-form-input
                  v-model="condDiseaseCodesModel"
                  class="d-none"
                />
                <div
                  v-for="(group, gIdx) in liveinfo.condDiseaseCodeGroups"
                  :key="`disease-${gIdx}`"
                  class="d-flex align-items-center"
                  :class="{ 'mt-25': gIdx !== 0 }"
                >
                  <b-form-input
                    v-model="group.code"
                    placeholder="코드를 입력하세요 (쉼표 구분 시 OR)"
                    :state="errors.length > 0 ? false : null"
                  />
                  <b-button
                    v-if="liveinfo.condDiseaseCodeGroups.length > 1"
                    variant="outline-danger"
                    size="sm"
                    class="ml-1"
                    @click="removeCodeGroup(liveinfo.condDiseaseCodeGroups, gIdx)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                  <b-button
                    v-if="gIdx === liveinfo.condDiseaseCodeGroups.length - 1"
                    variant="outline-primary"
                    size="sm"
                    class="ml-1"
                    @click="addCodeGroup(liveinfo.condDiseaseCodeGroups)"
                  >
                    <feather-icon icon="PlusIcon" />
                  </b-button>
                </div>
                <small class="text-danger">
                  {{
                    errors.length > 0
                      ? '처방팝업 사용시, 조건은 한가지 이상 반드시 입력되어야 합니다.'
                      : ''
                  }}
                </small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="검사코드"
              :rules="{
                requiredIf: !condDrugCodesModel && !condDiseaseCodesModel,
              }"
            >
              <b-form-group
                label="검사코드 (같은 칸 = OR / 칸 추가 = AND) (※ 검사는 원코드 5자리로 입력. e.g. 'D2280000'[X] 'D2280'[O])"
                label-for="liveinfo-lab-codes"
              >
                <b-form-input
                  v-model="condLabCodesModel"
                  class="d-none"
                />
                <div
                  v-for="(group, gIdx) in liveinfo.condLabCodeGroups"
                  :key="`lab-${gIdx}`"
                  class="d-flex align-items-center"
                  :class="{ 'mt-25': gIdx !== 0 }"
                >
                  <b-form-input
                    v-model="group.code"
                    placeholder="코드를 입력하세요 (쉼표 구분 시 OR)"
                    :state="errors.length > 0 ? false : null"
                  />
                  <b-button
                    v-if="liveinfo.condLabCodeGroups.length > 1"
                    variant="outline-danger"
                    size="sm"
                    class="ml-1"
                    @click="removeCodeGroup(liveinfo.condLabCodeGroups, gIdx)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                  <b-button
                    v-if="gIdx === liveinfo.condLabCodeGroups.length - 1"
                    variant="outline-primary"
                    size="sm"
                    class="ml-1"
                    @click="addCodeGroup(liveinfo.condLabCodeGroups)"
                  >
                    <feather-icon icon="PlusIcon" />
                  </b-button>
                </div>
                <small class="text-danger">
                  {{
                    errors.length > 0
                      ? '처방팝업 사용시, 조건은 한가지 이상 반드시 입력되어야 합니다.'
                      : ''
                  }}
                </small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="알림창 내용 (※ 처방팝업과 스케줄팝업 문구는 반드시 다르게 설정하여 주세요.)"
              label-for="liveinfo-ipu-content"
            >
              <validation-provider
                #default="{ errors }"
                name="알림창 내용"
                rules="required|popupContent"
              >
                <tinymce-editor
                  v-model="liveinfo.ipuContent"
                  :is-table="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-card>
    <!-- 간편처방등록(contentType 8)은 스케줄 팝업 제외 -->
    <b-card v-show="contentType != 8">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start"
        >
          <feather-icon
            icon="ClockIcon"
            size="19"
          />
          <h4
            class="mb-0 ml-50"
            style="min-width: 150px"
          >
            스케줄 팝업
          </h4>
          <b-form-checkbox
            v-model="liveinfo.isScheduleUse"
            switch
            inline
            class="custom-control-info"
            style="min-width: 120px"
          >
            {{ liveinfo.isScheduleUse ? '사용' : '사용안함' }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <validation-observer ref="liveinfoIsScheduleRules">
        <b-row
          v-if="liveinfo.isScheduleUse"
          class="mt-1"
        >
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="알림기간(Fr)"
              label-for="liveinfo-spu-start-date"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                name="알림기간(Fr)"
                :rules="{
                  required: true,
                  before: liveinfo.spuEndDate,
                  dateBetween: [liveinfo.startDate, liveinfo.endDate],
                }"
              >
                <b-form-datepicker
                  id="liveinfo-spu-start-date"
                  v-model="liveinfo.spuStartDate"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">
                  {{
                    failedRules.hasOwnProperty('dateBetween')
                      ? '스케줄 팝업 기간은 게시기간 이내로 제한됩니다.'
                      : errors[0]
                  }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            v-if="!liveinfo.isSpuOneTime"
            cols="12"
            md="3"
          >
            <b-form-group
              label="알림기간(To)"
              label-for="liveinfo-spu-end-date"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                name="알림기간(To)"
                :rules="{
                  required: true,
                  after: liveinfo.spuStartDate,
                  dateBetween: [liveinfo.startDate, liveinfo.endDate],
                }"
              >
                <b-form-datepicker
                  id="liveinfo-spu-end-date"
                  v-model="liveinfo.spuEndDate"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">
                  {{
                    failedRules.hasOwnProperty('dateBetween')
                      ? '스케줄 팝업 기간은 게시기간 이내로 제한됩니다.'
                      : errors[0]
                  }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!--
          해당 기능은 사업/기획 협의하에 보류하고 일회 알람의 경우 전날 설정하는 것으로 협의
          <b-col
            cols="12"
            md="3"
          >
            <span class="font-weight-bold">일회 알림</span>
            <b-form-checkbox
              v-model="liveinfo.isSpuOneTime"
              class="custom-control-info mt-1 ml-1"
              @change="spuOneTimeChange()"
            />
          </b-col> -->
          <b-col
            cols="12"
            md="6"
          />
          <b-col cols="12">
            <b-form-group
              label="알림 유지시간"
              label-for="liveinfo-spu-delay-sec"
            >
              <validation-provider
                #default="{ errors }"
                name="알림 유지시간"
                rules="required"
              >
                <v-select
                  id="liveinfo-spu-delay-sec"
                  v-model="liveinfo.spuDelaySec"
                  :options="constCodes.selectTimes"
                  :reduce="(option) => option.code"
                  :state="errors.length > 0 ? false : null"
                  style="width: 210px"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <label>알림 시간 선택</label>
          </b-col>
          <b-col
            v-for="(sched, idx) in liveinfo.schedules"
            :id="`schedules${sched.id}`"
            :key="sched.id"
            cols="12"
            class="d-flex align-items-center justify-content-start"
            :class="{ 'mt-25': idx !== 0 }"
          >
            <template v-if="sched.popUpType === 2">
              <validation-provider
                #default="{ errors }"
                name="알림 시간 선택"
                rules="required"
              >
                <v-date-picker
                  v-model="sched.noticeTime"
                  type="time"
                  format="HH:mm"
                  value-type="format"
                  placeholder="HH:mm"
                  :time-picker-options="{
                    start: '08:00',
                    step: '00:05',
                    end: '20:00',
                  }"
                  class="mr-1"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <b-button
                v-if="idx !== getSchedIdxFirstOrLast(2, true)"
                variant="outline-danger"
                size="sm"
                class="mr-1"
                @click="liveinfo.schedules.splice(idx, 1)"
              >
                <feather-icon
                  icon="XIcon"
                  class="mr-25"
                />
                <span>삭제</span>
              </b-button>
              <b-button
                v-if="idx === getSchedIdxFirstOrLast(2, false)"
                variant="outline-primary"
                size="sm"
                @click="
                  liveinfo.schedules.push({
                    noticeTime: null,
                    popUpType: 2,
                  })
                "
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
                />
                <span>추가</span>
              </b-button>
            </template>
          </b-col>
          <b-col
            cols="12"
            class="mt-1"
          >
            <b-form-group
              label="알림창 내용 (※ 처방팝업과 스케줄팝업 문구는 반드시 다르게 설정하여 주세요.)"
              label-for="liveinfo-spu-content"
            >
              <validation-provider
                #default="{ errors }"
                name="알림창 내용"
                rules="required|popupContent"
              >
                <tinymce-editor
                  v-model="liveinfo.spuContent"
                  :is-table="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-card>

    <!-- 진료 후 팝업 (4개 광고 단위 공통) -->
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start"
        >
          <feather-icon
            icon="CoffeeIcon"
            size="19"
          />
          <h4
            class="mb-0 ml-50"
            style="min-width: 150px"
          >
            진료 후 팝업
          </h4>
          <b-form-checkbox
            v-model="liveinfo.isAfterConsultPopup"
            switch
            inline
            class="custom-control-info"
            style="min-width: 120px"
          >
            {{ liveinfo.isAfterConsultPopup ? '사용' : '사용안함' }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row
        v-if="liveinfo.isAfterConsultPopup"
        class="mt-1"
      >
        <b-col cols="12">
          <small class="text-muted">
            tip. 대기환자 0명 감지 후 10초 시점에 노출되는 팝업, 동시 최대 2개 노출(자동 균등), 컨텐츠에 설정된 타겟 사용, 팝업기간에 한 번만 노출
          </small>
        </b-col>
      </b-row>
      <validation-observer ref="liveinfoIsAcpRules">
        <b-row
          v-if="liveinfo.isAfterConsultPopup"
          class="mt-1"
        >
          <!-- 3. acpStartDate — 알림기간(Fr) -->
          <b-col
            cols="12"
            md="4"
            class="mt-1"
          >
            <b-form-group
              label="알림기간(Fr)"
              label-for="liveinfo-acp-start-date"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                name="알림기간(Fr)"
                :rules="{
                  required: true,
                  before: liveinfo.acpEndDate,
                  dateBetween: [liveinfo.startDate, liveinfo.endDate],
                }"
              >
                <b-form-datepicker
                  id="liveinfo-acp-start-date"
                  v-model="liveinfo.acpStartDate"
                  placeholder="알림기간(Fr)"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">
                  {{
                    failedRules.hasOwnProperty('dateBetween')
                      ? '진료 후 팝업 기간은 게시기간 이내로 제한됩니다.'
                      : errors[0]
                  }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- 3. acpEndDate — 알림기간(To) -->
          <b-col
            cols="12"
            md="4"
            class="mt-1"
          >
            <b-form-group
              label="알림기간(To)"
              label-for="liveinfo-acp-end-date"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                name="알림기간(To)"
                :rules="{
                  required: true,
                  after: liveinfo.acpStartDate,
                  dateBetween: [liveinfo.startDate, liveinfo.endDate],
                }"
              >
                <b-form-datepicker
                  id="liveinfo-acp-end-date"
                  v-model="liveinfo.acpEndDate"
                  placeholder="알림기간(To)"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">
                  {{
                    failedRules.hasOwnProperty('dateBetween')
                      ? '진료 후 팝업 기간은 게시기간 이내로 제한됩니다.'
                      : errors[0]
                  }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Grid line-break — 알림기간과 알림 시점 사이 강제 개행 · 알림기간 우측 md=4 공간 비움 -->
          <div class="w-100" />

          <!-- 4. 알림 시점 | 알림 유지시간 | 팝업기간 내 최대 노출 수 (3열)
               노출 순서 안내는 4-4로 별도 행(cols=12) 이동 -->
          <!-- 4-1. 알림 시점 콤보 (acpStartHour/acpEndHour 프리셋 매핑 UI - UI 전용) -->
          <b-col
            cols="12"
            md="4"
            class="mt-1"
          >
            <b-form-group
              label="알림 시점"
              label-for="liveinfo-acp-time-range"
            >
              <v-select
                id="liveinfo-acp-time-range"
                v-model="acpTimeRangeSelected"
                :options="constCodes.acpTimeRanges"
                :reduce="(option) => option.code"
                :clearable="false"
                @input="onAcpTimeRangeChange"
              />
              <!-- 직접지정 시 시작/종료 시각 서브 콤보 노출 -->
              <b-row
                v-if="acpTimeRangeSelected === 99"
                class="mt-1"
              >
                <!-- acpStartHour — 시작 시각 -->
                <b-col cols="6">
                  <validation-provider
                    #default="{ errors }"
                    name="시작 시각"
                    rules="required"
                  >
                    <label for="liveinfo-acp-start-hour">시작 시각</label>
                    <v-select
                      id="liveinfo-acp-start-hour"
                      v-model="liveinfo.acpStartHour"
                      :options="constCodes.acpHours"
                      :reduce="(option) => option.code"
                      :selectable="(option) => !liveinfo.acpEndHour || option.code <= liveinfo.acpEndHour"
                      :clearable="false"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <!-- acpEndHour — 종료 시각 -->
                <b-col cols="6">
                  <validation-provider
                    #default="{ errors, failedRules }"
                    name="종료 시각"
                    :rules="{
                      required: true,
                      acpEndHourAfter: liveinfo.acpStartHour,
                    }"
                  >
                    <label for="liveinfo-acp-end-hour">종료 시각</label>
                    <v-select
                      id="liveinfo-acp-end-hour"
                      v-model="liveinfo.acpEndHour"
                      :options="constCodes.acpHours"
                      :reduce="(option) => option.code"
                      :selectable="(option) => !liveinfo.acpStartHour || option.code >= liveinfo.acpStartHour"
                      :clearable="false"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">
                      {{
                        failedRules.hasOwnProperty('acpEndHourAfter')
                          ? '종료 시각은 시작 시각 이상이어야 합니다.'
                          : errors[0]
                      }}
                    </small>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <!-- 4-2. acpDelaySec — 알림 유지시간 -->
          <b-col
            cols="12"
            md="4"
            class="mt-1"
          >
            <b-form-group
              label="알림 유지시간"
              label-for="liveinfo-acp-delay-sec"
            >
              <validation-provider
                #default="{ errors }"
                name="알림 유지시간"
                rules="required"
              >
                <v-select
                  id="liveinfo-acp-delay-sec"
                  v-model="liveinfo.acpDelaySec"
                  :options="constCodes.selectTimes"
                  :reduce="(option) => option.code"
                  :clearable="false"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- 4-3. acpPopCount — 팝업기간 전체 최대 노출 수 -->
          <b-col
            cols="12"
            md="4"
            class="mt-1"
          >
            <b-form-group
              label="팝업기간 내 최대 노출 수"
              label-for="liveinfo-acp-pop-count-period"
            >
              <b-form-spinbutton
                id="liveinfo-acp-pop-count-period"
                v-model="liveinfo.acpPopCount"
                min="1"
                max="100"
                inline
              />
            </b-form-group>
          </b-col>
          <!-- 4-4. 노출 순서 자동 조정 안내 (편집 불가 텍스트) -->
          <b-col
            cols="12"
            class="mt-1"
          >
            <b-form-group label="노출 순서">
              <small class="text-muted">
                전날 노출이 상대적으로 적었던 팝업을 자동으로 우선 노출합니다. 별도 가중치 설정 없이 시스템이 균등 노출을 보정합니다.
              </small>
            </b-form-group>
          </b-col>
          <!-- 5. acpContent — 알림창 내용 -->
          <b-col
            cols="12"
            class="mt-1"
          >
            <b-form-group
              label="알림창 내용"
              label-for="liveinfo-acp-content"
            >
              <validation-provider
                #default="{ errors }"
                name="알림창 내용"
                rules="required|popupContent"
              >
                <tinymce-editor
                  v-model="liveinfo.acpContent"
                  :is-table="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- 6. 좌측 컬럼 — 알림창 버튼 텍스트 + 알림창 컬러 (세로 배치) -->
          <b-col
            cols="12"
            md="7"
            class="mt-1"
          >
            <b-form-group
              label="알림창 버튼 텍스트"
              label-for="liveinfo-acp-button-text"
            >
              <validation-provider
                #default="{ errors }"
                name="알림창 버튼 텍스트"
                rules="required|max:20"
              >
                <b-form-input
                  id="liveinfo-acp-button-text"
                  v-model="liveinfo.acpButtonText"
                  maxlength="20"
                  placeholder="상세정보 보기"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <small class="text-muted">최대 20자</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="알림창 컬러"
              label-for="liveinfo-acp-color-type"
            >
              <b-form-radio-group
                id="liveinfo-acp-color-type"
                v-model="liveinfo.acpColorType"
                :options="constCodes.acpColorTypes"
                value-field="code"
                text-field="label"
              />
            </b-form-group>
          </b-col>
          <!-- 6. 우측 컬럼 — 알림창 미리보기 (acpContent/acpButtonText/acpColorType 시각화 · UI 전용) -->
          <b-col
            cols="12"
            md="5"
            class="mt-1"
          >
            <label>알림창 미리보기</label>
            <!-- 실제 App: IE 기반 WebBrowser 렌더링 · 270×220 크기 · 개발자 참고 (사용자 노출 X) -->
            <small class="text-muted"> 색상 설정 등을 확인하기 위한 참고용 프리뷰로, 실제 팝업과 다를 수 있습니다.</small>
            <div class="acp-preview-wrap">
              <div class="acp-preview">
                <!-- Header — 컬러 preset 따라 배경·텍스트 색 변경 (30px) -->
                <div
                  class="acp-preview__header"
                  :class="`acp-preview__header--${liveinfo.acpColorType === 2 ? 'blue' : 'gray'}`"
                >
                  <span class="acp-preview__title">닥터인포 알림</span>
                  <span class="acp-preview__close">×</span>
                </div>
                <!-- Body: iframe으로 격리해서 IE 엔진 유사 렌더링 (WebBrowser: 270×160)
                     App은 ScrollBarsEnabled=false 이므로 미리보기도 scrolling="no" 로 스크롤 억제 -->
                <iframe
                  class="acp-preview__body"
                  :srcdoc="acpPreviewHtml"
                  sandbox=""
                  frameborder="0"
                  scrolling="no"
                />
                <!-- Bottom button — preset 무관 고정 Gray (기획서 요구: 하단은 색 안 바뀜) · 30px · 맑은 고딕 8pt -->
                <div class="acp-preview__bottom">
                  {{ liveinfo.acpButtonText || '상세정보 보기' }}
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </validation-observer>
    </b-card>

    <!-- 환자 타입 조회 -->
    <b-card v-if="contentType === 1">
      <!-- 토글 -->
      <b-row class="align-items-center">
        <b-col class="d-flex align-items-center">
          <feather-icon icon="UsersIcon" size="19" />
          <h4 class="mb-0 ml-50" style="min-width: 150px">
            환자 타입 조회
          </h4>
          <b-form-checkbox
            v-model="liveinfo.isPatientType"
            switch
            inline
            class="custom-control-info"
            style="min-width: 120px"
            @change="changePatientType"
          >
            {{ liveinfo.isPatientType ? '사용' : '사용안함' }}
          </b-form-checkbox>
        </b-col>
      </b-row>

      <template v-if="liveinfo.isPatientType">
        <b-row class="mt-1">
          <b-col>
            <small class="text-primary">
              <strong>① 실행 대상: 상단 '약품정보 노출 조건'에서 설정한 진료과 및 지역의 요양기관</strong>
              (※ 의사 단위로 적용되는 '타겟그룹'과 함께 사용 불가)
            </small>
          </b-col>
        </b-row>
        <b-row class="mt-25">
          <b-col>
            <small>
              (진료과: <strong class="text-primary">{{ liveinfo.condDeptNames || '미지정' }}</strong>
              &nbsp;,&nbsp;
              지역: <strong class="text-primary">{{ liveinfo.condRegionNames || '미지정' }}</strong>)
            </small>
          </b-col>
        </b-row>

        <hr class="my-1">

        <!-- 회차별 기간 설정 -->
        <h5 class="mb-50">
          회차별 기간 설정
        </h5>
        <div class="mb-1">
          <b-button variant="outline-primary" @click.prevent="addPatientTypePeriod">
            회차 추가
          </b-button>
          <b-button variant="outline-danger" @click.prevent="removePatientTypePeriod()" class="ml-1">
            전체 초기화
          </b-button>
        </div>

        <validation-observer ref="ptPeriodRules">
        <div
          v-for="(period, rIdx) in (liveinfo.patientType && liveinfo.patientType.periods) || []"
          :key="`period-${rIdx}`"
          class="border rounded p-1 mb-1"
        >
          <b-row class="align-items-center mb-1">
            <b-col>
              <h6 class="mb-0 font-weight-bold">{{ rIdx + 1 }}회차</h6>
            </b-col>
            <b-col cols="auto">
              <b-button :disabled="isRoundDeleteDisabled(rIdx)" variant="flat-danger" size="sm" @click.prevent="removePatientTypePeriod(rIdx)">
                <feather-icon icon="Trash2Icon" size="14" />
              </b-button>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="4" class="border-right pr-2">
              <b-form-group>
                <template #label>
                  과거 진료내역 조회 기간
                  <small class="text-muted ml-25">최대 60개월</small>
                </template>
                <div class="d-flex align-items-start">
                  <validation-provider
                    #default="{ errors, failedRules }"
                    :name="`${rIdx + 1}회차 데이터조회 시작일`"
                    :rules="{
                      required: true,
                      dateBefore: period.dataEndDate,
                    }"
                    style="flex: 1 1 0%; min-width: 0;"
                  >
                    <b-form-datepicker
                      v-model="period.dataStartDate"
                      placeholder="시작일"
                      :disabled="isPatientTypePeriodDisabled(rIdx, 'data')"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">
                      {{ failedRules.required ? '[시작일(Fr)]는(은) 필수 입력입니다.'
                        : failedRules.dateBefore ? '[시작일(Fr)]은 [종료일(To)]보다 늦을 수 없습니다.'
                        : '' }}
                    </small>
                  </validation-provider>
                  <span class="mx-50 pt-50">~</span>
                  <validation-provider
                    #default="{ errors, failedRules }"
                    :name="`${rIdx + 1}회차 데이터조회 종료일`"
                    :rules="{
                      required: true,
                      dateAfter: period.dataStartDate,
                      dateWithinMonths: { startDate: period.dataStartDate, months: 60 },
                    }"
                    style="flex: 1 1 0%; min-width: 0;"
                  >
                    <b-form-datepicker
                      v-model="period.dataEndDate"
                      placeholder="종료일"
                      :disabled="isPatientTypePeriodDisabled(rIdx, 'data')"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">
                      {{ failedRules.required ? '[종료일(To)]는(은) 필수 입력입니다.'
                        : failedRules.dateAfter ? '[시작일(Fr)]은 [종료일(To)]보다 늦을 수 없습니다.'
                        : failedRules.dateWithinMonths ? '최대 60개월까지 설정 가능합니다.'
                        : '' }}
                    </small>
                  </validation-provider>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group>
                <template #label>
                  사전 스크리닝 기간
                  <small class="ml-50 text-secondary"> (게시기간 : </small>
                  <small class="ml-50 text-primary">{{ `${!(liveinfo.startDate) ? '미지정' : liveinfo.startDate}` }}</small>
                  <small class="ml-50 text-secondary">~</small>
                  <small class="ml-50 text-primary">{{ ` ${!(liveinfo.endDate) ? '미지정' : liveinfo.endDate}` }}</small>
                  <small class="text-secondary">) </small>
                </template>
                <div class="d-flex align-items-start">
                  <validation-provider
                    #default="{ errors, failedRules }"
                    :name="`${rIdx + 1}회차 사전스크리닝 시작일`"
                    :rules="{
                      required: true,
                      dateBetween: [liveinfo.startDate, liveinfo.endDate],
                      dateBefore: period.screeningEndDate,
                      dateOverlapStart: [rIdx, patientTypeScreeningPeriodSet],
                    }"
                    style="flex: 1 1 0%; min-width: 0;"
                  >
                    <b-form-datepicker
                      v-model="period.screeningStartDate"
                      placeholder="시작일"
                      :min="tomorrow"
                      :disabled="isPatientTypePeriodDisabled(rIdx, 'screening-start')"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">
                      {{ failedRules.required ? '[시작일(Fr)]는(은) 필수 입력입니다.'
                        : failedRules.dateBetween ? '게시 기간 내로 설정해 주세요.'
                        : failedRules.dateBefore ? '[시작일(Fr)]은 [종료일(To)]보다 늦을 수 없습니다.'
                        : failedRules.dateOverlapStart ? '다른 회차의 사전 스크리닝 기간과 겹치지 않게 입력해 주세요.'
                        : '' }}
                    </small>
                  </validation-provider>
                  <span class="mx-50 pt-50">~</span>
                  <validation-provider
                    #default="{ errors, failedRules }"
                    :name="`${rIdx + 1}회차 사전스크리닝 종료일`"
                    :rules="{
                      required: true,
                      dateBetween: [liveinfo.startDate, liveinfo.endDate],
                      dateAfter: period.screeningStartDate,
                      dateLess: period.popupStartDate,
                      dateOverlapEnd: [rIdx, patientTypeScreeningPeriodSet],
                    }"
                    style="flex: 1 1 0%; min-width: 0;"
                  >
                    <b-form-datepicker
                      v-model="period.screeningEndDate"
                      placeholder="종료일"
                      :min="today"
                      :disabled="isPatientTypePeriodDisabled(rIdx, 'screening-end')"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">
                      {{ failedRules.required ? '[종료일(To)]는(은) 필수 입력입니다.'
                        : failedRules.dateBetween ? '게시 기간 내로 설정해 주세요.'
                        : failedRules.dateAfter ? '[시작일(Fr)]은 [종료일(To)]보다 늦을 수 없습니다.'
                        : failedRules.dateLess ? '같은 회차의 팝업 노출 기간과 겹치지 않게 입력해 주세요.'
                        : failedRules.dateOverlapEnd ? '다른 회차의 사전 스크리닝 기간과 겹치지 않게 입력해 주세요.'
                        : '' }}
                    </small>
                  </validation-provider>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group>
                <template #label>
                  팝업 노출 기간
                  <small class="ml-50 text-secondary"> (게시기간 : </small>
                  <small class="ml-50 text-primary">{{ `${!(liveinfo.startDate) ? '미지정' : liveinfo.startDate}` }}</small>
                  <small class="ml-50 text-secondary">~</small>
                  <small class="ml-50 text-primary">{{ ` ${!(liveinfo.endDate) ? '미지정' : liveinfo.endDate}` }}</small>
                  <small class="text-secondary">) </small>
                </template>
                <div class="d-flex align-items-start">
                  <validation-provider
                    #default="{ errors, failedRules }"
                    :name="`${rIdx + 1}회차 팝업노출 시작일`"
                    :rules="{
                      required: true,
                      dateBetween: [liveinfo.startDate, liveinfo.endDate],
                      dateMore: period.screeningEndDate,
                      dateBefore: period.popupEndDate,
                      dateOverlapStart: [rIdx, patientTypePopupPeriodSet],
                    }"
                    style="flex: 1 1 0%; min-width: 0;"
                  >
                    <b-form-datepicker
                      v-model="period.popupStartDate"
                      placeholder="시작일"
                      :min="tomorrow"
                      :disabled="isPatientTypePeriodDisabled(rIdx, 'popup-start')"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">
                      {{ failedRules.required ? '[시작일(Fr)]는(은) 필수 입력입니다.'
                        : failedRules.dateBetween ? '게시 기간 내로 설정해 주세요.'
                        : failedRules.dateMore ? '같은 회차의 사전 스크리닝 기간과 겹치지 않게 입력해 주세요.'
                        : failedRules.dateBefore ? '[시작일(Fr)]은 [종료일(To)]보다 늦을 수 없습니다.'
                        : failedRules.dateOverlapStart ? '다른 회차의 팝업 노출 기간과 겹치지 않게 입력해 주세요.'
                        : '' }}
                    </small>
                  </validation-provider>
                  <span class="mx-50 pt-50">~</span>
                  <validation-provider
                    #default="{ errors, failedRules }"
                    :name="`${rIdx + 1}회차 팝업노출 종료일`"
                    :rules="{
                      required: true,
                      dateBetween: [liveinfo.startDate, liveinfo.endDate],
                      dateAfter: period.popupStartDate,
                      dateOverlapEnd: [rIdx, patientTypePopupPeriodSet],
                    }"
                    style="flex: 1 1 0%; min-width: 0;"
                  >
                    <b-form-datepicker
                      v-model="period.popupEndDate"
                      placeholder="종료일"
                      :min="today"
                      :disabled="isPatientTypePeriodDisabled(rIdx, 'popup-end')"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">
                      {{ failedRules.required ? '[종료일(To)]는(은) 필수 입력입니다.'
                        : failedRules.dateBetween ? '게시 기간 내로 설정해 주세요.'
                        : failedRules.dateAfter ? '[시작일(Fr)]은 [종료일(To)]보다 늦을 수 없습니다.'
                        : failedRules.dateOverlapEnd ? '다른 회차의 팝업 노출 기간과 겹치지 않게 입력해 주세요.'
                        : '' }}
                    </small>
                  </validation-provider>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <validation-provider name="회차" rules="required" v-slot="{ errors }">
          <input type="hidden" :value="(liveinfo.patientType && liveinfo.patientType.periods && liveinfo.patientType.periods.length) || ''" />
          <small v-if="errors[0]" class="text-danger">[회차]는(은) 필수 입력입니다.</small>
        </validation-provider>

        <hr class="my-1">

        <!-- 환자 타입(조건) 및 알림 팝업 설정 -->
        <div class="d-flex align-items-center mb-50">
          <h5 class="mb-0">
            환자 타입(조건) 및 알림 팝업 설정
          </h5>
          <b-badge
            v-b-tooltip.hover.right.html
            variant="light-secondary"
            style="padding: 0px; margin-left: 5px;"
            :title="`1회차 시작 후에는 타입을 추가/수정/삭제할 수 없습니다. 불가피하게 변경이 필요한 경우 회차 삭제를 통해 수집된 데이터를 전체 초기화하고 1회차부터 다시 진행해야 합니다.`"
          >
            <feather-icon icon="InfoIcon" />
          </b-badge>
        </div>
        <div class="mb-1">
          <b-button
            variant="outline-primary"
            :disabled="isPatientTypeStarted"
            @click.prevent="patientTypeSelect.open()"
          >
            타입 추가
          </b-button>
        </div>

        <b-row v-if="!liveinfo.patientType || !liveinfo.patientType.conds || !liveinfo.patientType.conds.length" class="mt-1">
          <b-col>
            <p class="text-secondary my-50">
              추가된 타입이 없습니다.
            </p>
            <validation-provider name="타입" rules="required" v-slot="{ errors }">
              <input type="hidden" :value="(liveinfo.patientType && liveinfo.patientType.conds && liveinfo.patientType.conds.length) || ''" />
              <small v-if="errors[0]" class="text-danger">[타입]는(은) 필수 입력입니다.</small>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row
          v-for="(cond, idx) in (liveinfo.patientType && liveinfo.patientType.conds) || []"
          :key="idx"
          class="mt-1 align-items-center border rounded p-1 mx-0"
        >
          <b-col cols="auto" class="font-weight-bold text-primary">
            Type{{ idx + 1 }}
          </b-col>
          <b-col>
            <div class="font-weight-bold mb-25">{{ cond.title }}</div>
            <span
              v-for="(label, labelIdx) in parsePatientTypeLabels(cond.conditionLabels)"
              :key="labelIdx"
              class="badge badge-light-primary mr-50 mb-25"
            >{{ label }}</span>
            <span
              v-if="!cond.conditionLabels || parsePatientTypeLabels(cond.conditionLabels).length === 0"
              class="text-secondary"
            >조건 없음</span>
          </b-col>
          <b-col cols="auto">
            <b-button
              variant="flat-secondary"
              size="sm"
              class="btn-icon mr-25"
              @click.prevent="patientTypeSelect.open(idx)"
            >
              <feather-icon icon="EditIcon" size="16" />
            </b-button>
            <b-button
              variant="flat-danger"
              size="sm"
              class="btn-icon"
              :disabled="isPatientTypeStarted"
              @click.prevent="removePatientTypeCond(idx)"
            >
              <feather-icon icon="Trash2Icon" size="16" />
            </b-button>
          </b-col>
        </b-row>
        </validation-observer>
      </template>
    </b-card>


    <!-- <major-select
      :show-major-select="showMajorSelect"
      :selected-value="liveinfo.condMajorCodes"
      @close="majorSelect.close"
    /> -->

    <region-select
      :show-region-select="showRegionSelect"
      :selected-value="liveinfo.condRegionCodes"
      @close="regionSelect.close"
    />

    <medi-dept-select
      :show-medi-dept-select="showMediDeptSelect"
      :selected-value="liveinfo.condDeptCodes"
      @close="mediDeptSelect.close"
    />

    <target-group-select
      :show-target-group-select="showTargetGroupSelect"
      @close="targetGroupSelect.close"
    />

    <!-- <live-di-section-select
      :show-live-di-section-select="showLiveDiSectionSelect"
      @close="liveDiSectionSelect.close"
    /> -->

    <main-top-fix-manage
      :show-main-top-fix-manage="showMainTopFixManage"
      @close="mainTopFixManage.close"
    />

    <interest-content-select
      :show-content-select="showInterestContentSelect"
      :selected-value="liveinfo.interestContentIds"
      @close="interestContentSelect.close"
    />

    <patient-type-select
      v-if="contentType === 1"
      :show-patient-type-select="showPatientTypeSelect"
      :selected-value="patientTypeSelectCond"
      :is-cond-readonly="isPatientTypeStarted"
      @close="patientTypeSelect.close"
    />
  </div>
</template>

<script>
import axios from '@axios'
import dayjs from 'dayjs'
import vSelect from 'vue-select'
import {
  BFormSpinbutton, VBTooltip, BButton, BFormInput,
  BFormDatepicker, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  ref, watch, getCurrentInstance, computed,
} from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  required,
  between,
  dateBetween,
  after,
  before,
  requiredIf,
  dateOverlapStart,
  dateOverlapEnd,
  dateWithinMonths,
  dateLess,
  dateMore,
} from '@validations'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { errorFormatter, arrayJoinStr } from '@core/utils/filter'
// import MajorSelect from '@/views/apps/popup/MajorSelect.vue'
import RegionSelect from '@/views/apps/popup/RegionSelect.vue'
import MediDeptSelect from '@/views/apps/popup/MediDeptSelect.vue'
// import LiveDiSectionSelect from "@/views/apps/contents/druginfo-manage/LiveDiSectionSelect.vue"
import TinymceEditor from '@/views/TinyMCE.vue'
import { cloneDeep } from 'lodash'
import { constCodes, getCodeLabel } from '@/common/custom/content-type'
import ViewListBadge from '@/views/apps/inline/ViewListBadge.vue'
import TargetGroupSelect from "@/views/apps/contents/target-group-manage/TargetGroupSelect.vue"
import MainTopFixManage from "@/views/apps/contents/main-top-fix-manage/MainTopFixManage.vue"
import InterestContentSelect from "@/views/apps/contents/interest-content/InterestContentSelect.vue"
import PatientTypeSelect from '@/views/apps/contents/druginfo-manage/PatientTypeSelect.vue'

export default {
  components: {
    vSelect,
    BFormSpinbutton,
    BButton,
    BFormInput,
    BFormDatepicker,
    BBadge,
    RegionSelect,
    MediDeptSelect,
    ValidationProvider,
    ValidationObserver,
    TinymceEditor,
    TargetGroupSelect,
    MainTopFixManage,
    ViewListBadge,
    InterestContentSelect,
    PatientTypeSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    liveinfoId: {
      type: Number,
      default: null,
      required: false,
    },
    contentType: {
      type: Number,
      default: null,
      required: false,
    },
    clearFlag: {
      type: Boolean,
      required: true,
    },
    validFlag: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    // 클래스가 변경되었을 때 감시
    const targetElement = document.body
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // 클래스가 변경되면 isDarkMode 변수를 업데이트
          this.isDarkMode = targetElement.classList.contains('dark-layout')
        }
      })
    })
    observer.observe(targetElement, { attributes: true })
  },
  setup(props, { emit }) {
    watch(
      () => props.clearFlag,
      () => {
        resetLiveinfoData()
      },
    )
    watch(
      () => props.validFlag,
      () => {
        validate()
      },
    )
    watch(
      () => props.liveinfoId,
      newVal => {
        fetchLiveInfo(newVal)
      },
    )

    extend('popupContent', {
      validate: value => {
        if (value !== null) {
          const val = value.substring(value.indexOf('<td>') + 4, value.indexOf('</td>')).replace(/&nbsp;/g, '')

          if (val.trim().length === 0) return '[{_field_}]는(은) 필수 입력입니다.'
        }

        return true
      },
    })

    // 진료 후 팝업 - 종료 시각 >= 시작 시각 검증
    extend('acpEndHourAfter', {
      params: ['startHour'],
      validate: (value, { startHour }) => {
        if (value == null || startHour == null) return true
        return Number(value) >= Number(startHour)
      },
      message: '종료 시각은 시작 시각 이상이어야 합니다.',
    })

    const isDarkMode = ref(document.body.classList.contains('dark-layout'))

    const getInputGroupStyle = (size, disabled) => {
      let rsStyle = ''

      // size 가 sm인 경우 높이 제한
      if (size === 'sm') {
        rsStyle += "height: 2.142rem;"
      }

      // dark-layout 클래스가 있으면 스타일 적용
      if (isDarkMode.value && disabled) {
        rsStyle += " opacity: 0.5;"
      }

      return rsStyle
    }

    const dateDisabled = (ymd, date, includeToday = null) => {
      // 오늘 or 특정 날짜 이전 선택 불가(ymd 시간에 따라 오늘 선택 가능)
      const standardDate = date !== null ? dayjs(date).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD')
      if (includeToday) return new Date(ymd) <= new Date(standardDate)
      return new Date(ymd) < new Date(standardDate)
    }

    const getSchedIdxFirstOrLast = (popUpType, isFirst) => {
      let rIdx = -1
      for (let i = 0; i < liveinfo.value.schedules.length; i += 1) {
        if (popUpType === liveinfo.value.schedules[i].popUpType) {
          rIdx = i
          if (isFirst) return rIdx
        }
      }
      return rIdx
    }

    const toast = useToast()
    const instance = getCurrentInstance()
    const refs = instance.proxy.$refs
    const bvModal = instance.proxy.$bvModal
    const today = dayjs().format('YYYY-MM-DD')
    const tomorrow = dayjs().add(1, 'day').format('YYYY-MM-DD')

    const editorOptions = {
      placeholder: '팝업 알림창 내용을 입력하세요',
      preserveWhitespace: true,
    }
    
    const isStarted = ref(false)  // 게시기간이 시작되었는지 판별
    const isMainTopFixed = ref(false)  // 메인 상단고정 사용중인지 판별

    const liveinfoInitState = {
      liveInfoId: null,
      contentType: null,
      title: null,
      isUse: true,
      htmlContent: null,

      // 게시 기간
      startDate: null,
      endDate: null,

      // 알림 노출 조건
      condDeptCodes: null,
      condDeptNames: null,
      condMajorCodes: '0', // not null
      condMajorNames: '전체',
      condRegionCodes: null,
      condRegionNames: null,
      minAge: 0,
      maxAge: 120,
      targetGroupId: null,
      targetGroupTitle: null,

      condSetType: 11, // 11 : 진료과/지역별 사용자 | 12 : 타겟그룹

      // 메인노출
      isMainView: false,
      mainStartDate: null,
      mainEndDate: null,
      
      // 메인 상단고정
      isMainTopFix: false,

      // 처방 팝업
      isInfoPopUp: false,
      isInfoPopUpOr: false,
      ipuContent: null,
      ipuStartDate: null,
      ipuEndDate: null,
      ipuPopCount: 1,
      isImmediate: true,
      ipuDelaySec: 10,

      // 처방팝업 조건코드 그룹 (각 원소 = 한 칸, 칸 내 OR / 칸 간 AND)
      condDrugCodeGroups: [{ code: '' }],
      condDiseaseCodeGroups: [{ code: '' }],
      condLabCodeGroups: [{ code: '' }],

      // 환자 타입 조회
      isPatientType: false,
      patientType: null,

      // 라이브DI 속성 (컨텐츠가 라이브DI인 경우)
      isLiveDi: false,
      liveDiTitle: null,
      isLiveDiOr: false,
      // 라이브DI 조건코드 그룹 (각 원소 = 한 칸, 칸 내 OR / 칸 간 AND)
      liveDiCondDrugCodeGroups: [{ code: '' }],
      liveDiCondDiseaseCodeGroups: [{ code: '' }],
      liveDiCondLabCodeGroups: [{ code: '' }],
      liveDiStartDate: null,
      liveDiEndDate: null,

      // 스케줄 팝업
      isScheduleUse: false,
      spuStartDate: null,
      spuEndDate: null,
      spuContent: null,
      spuDelaySec: 10,

      // 진료 후 팝업 (After-Consult Popup) — UI 표시 순서와 일치
      isAfterConsultPopup: false,
      acpContent: null,      // 알림창 내용 (HTML)
      acpButtonText: '상세정보 보기',
      acpColorType: 1,       // 1: Gray, 2: Blue
      acpStartDate: null,
      acpEndDate: null,
      acpStartHour: 12,      // 시작 시각 (0~24, 기본 12)
      acpEndHour: 14,        // 종료 시각 (0~24, 기본 14)
      acpDelaySec: 10,       // 알림 유지시간 (10/30/60/300)
      acpPopCount: 1,        // 팝업기간 전체 최대 노출 수 (min=1, max=100)

      isCondDeptDrInfo: false,

      schedules: [
        { noticeTime: null, popUpType: 1 }, // 처방 알림
        { noticeTime: null, popUpType: 2 }, // 스케줄 알림
      ],

      isSpuOneTime: false,

      // 관심 컨텐츠 유형 (복수 선택 — ID 콤마 구분, 이름 쉼표 구분)
      interestContentIds : null,
      interestContentTitles : null,
    }

    const liveinfo = ref(cloneDeep(liveinfoInitState))

    // ===== 진료 후 팝업 - 알림 시점 콤보 상태 =====
    // 저장 필드는 acpStartHour/acpEndHour(시각 값). 콤보 선택값 자체는 UI 전용.
    // 12/11/13 = 기본 프리셋(각 +2시간), 99 = 직접지정
    const acpTimeRangeSelected = ref(12)

    // ===== 진료 후 팝업 - 미리보기 iframe srcdoc =====
    // App PopupNotifierForm 은 WinForms WebBrowser(IE 엔진) 로 acpContent HTML을 raw 렌더링.
    // App은 `body {padding: 0; margin: 0}` 전제로 270x160 크기 HTML을 그대로 표시하므로
    // 미리보기도 body padding/margin 을 0으로 두어야 실제 App 렌더와 크기 일치.
    const acpPreviewHtml = computed(() => {
      const raw = liveinfo.value.acpContent || '<div style="color:#888;padding:8px;">알림창 내용을 입력하세요.</div>'
      return `<!DOCTYPE html>
<html>
<head>
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<style>
body { margin: 0; padding: 0; font-family: '맑은 고딕', 'Malgun Gothic', sans-serif; font-size: 12px; color: #000; background: #ffffff; overflow: hidden; }
img { max-width: 100%; }
</style>
</head>
<body>${raw}</body>
</html>`
    })

    const onAcpTimeRangeChange = code => {
      if (code === 12) {
        liveinfo.value.acpStartHour = 12
        liveinfo.value.acpEndHour = 14
      } else if (code === 11) {
        liveinfo.value.acpStartHour = 11
        liveinfo.value.acpEndHour = 13
      } else if (code === 13) {
        liveinfo.value.acpStartHour = 13
        liveinfo.value.acpEndHour = 15
      }
      // code === 99(직접지정)일 때는 사용자가 콤보로 직접 값 조정
    }

    // 조회한 acpStartHour/acpEndHour → 콤보 선택값 역매핑
    const syncAcpTimeRangeFromValues = () => {
      const s = liveinfo.value.acpStartHour
      const e = liveinfo.value.acpEndHour
      if (s === 12 && e === 14) acpTimeRangeSelected.value = 12
      else if (s === 11 && e === 13) acpTimeRangeSelected.value = 11
      else if (s === 13 && e === 15) acpTimeRangeSelected.value = 13
      else acpTimeRangeSelected.value = 99
    }

    // ===== 처방팝업·라이브DI 조건코드 그룹(복수 입력칸) 관련 =====
    // 칸 추가/삭제
    const addCodeGroup = groups => groups.push({ code: '' })
    const removeCodeGroup = (groups, idx) => groups.splice(idx, 1)
    // 칸 배열 → 전체 코드 평탄화 문자열 (교차 필수입력 검증용)
    const joinGroups = groups => (groups || [])
      .map(g => (g && g.code ? String(g.code).trim() : ''))
      .filter(Boolean)
      .join(',')
    // 칸 배열 → 저장 전송용 문자열 배열 (빈 칸 제외)
    const groupsToStrings = groups => (groups || [])
      .map(g => (g && g.code ? String(g.code).trim() : ''))
      .filter(Boolean)
    // 검증 추적용(숨김 input) 읽기전용 모델
    const condDrugCodesModel = computed(() => joinGroups(liveinfo.value.condDrugCodeGroups))
    const condDiseaseCodesModel = computed(() => joinGroups(liveinfo.value.condDiseaseCodeGroups))
    const condLabCodesModel = computed(() => joinGroups(liveinfo.value.condLabCodeGroups))
    const liveDiCondDrugCodesModel = computed(() => joinGroups(liveinfo.value.liveDiCondDrugCodeGroups))
    const liveDiCondDiseaseCodesModel = computed(() => joinGroups(liveinfo.value.liveDiCondDiseaseCodeGroups))
    const liveDiCondLabCodesModel = computed(() => joinGroups(liveinfo.value.liveDiCondLabCodeGroups))

    const liveDiEndDateNextDay = computed(() => (liveinfo.value.liveDiEndDate !== null ? dayjs(liveinfo.value.liveDiEndDate).add(1, 'day') : null))

    // liveDiEndDate, EndDate 백업
    const originalLiveDiEndDate = ref(null)
    const originalLiveInfoEndDate = ref(null)

    const resetLiveinfoData = () => {
      // 불러온 엔티티가 추가한 잔존 키 제거 + 배열(스케줄/조건코드 그룹) 반응형 복원을 위해 객체 통째 교체
      liveinfo.value = cloneDeep(liveinfoInitState)
      savedPeriodDates.value = []
      originalLiveDiEndDate.value = null
      originalLiveInfoEndDate.value = null
      acpTimeRangeSelected.value = 12 // 진료 후 팝업 시점 콤보 기본값

      isStarted.value = false // 게시여부 초기화
      isMainTopFixed.value = false // 메인상단고정여부 초기화
      showMainTopFixManageGuide.value = false // 우선순위 설정 버튼 가이드 문구 표시여부 초기화

      refs.liveinfoFormRules.reset()
      if (refs.liveinfoMainRules) refs.liveinfoMainRules.reset()
      refs.liveinfoIsInfoPopRules.reset()
      refs.liveinfoIsLiveDiRules.reset()
      refs.liveinfoIsScheduleRules.reset()
      if (refs.liveinfoIsAcpRules) refs.liveinfoIsAcpRules.reset()
      refs.condSetTypeFormRules.reset()

    }

    const showMediDeptSelect = ref(false)
    const mediDeptSelect = {
      close: rs => {
        showMediDeptSelect.value = false

        if (rs) {
          liveinfo.value.condDeptCodes = arrayJoinStr(rs, 'code')
          liveinfo.value.condDeptNames = arrayJoinStr(rs, 'label')
        }
      },
    }

    const showRegionSelect = ref(false)
    const regionSelect = {
      close: rs => {
        showRegionSelect.value = false

        if (rs) {
          liveinfo.value.condRegionCodes = arrayJoinStr(rs, 'code')
          liveinfo.value.condRegionNames = arrayJoinStr(rs, 'label')
        }
      },
    }

    // 타겟그룹 지정
    const showTargetGroupSelect = ref(false)
    const targetGroupSelect = {
      close: rs => {
        showTargetGroupSelect.value = false
        if (rs) {
          liveinfo.value.targetGroupId = rs.id
          liveinfo.value.targetGroupTitle = rs.targetGroupTitle
        }
      },
    }

    // 우선순위 설정 (신규 컨텐츠인 경우 팝업 불가, "사용" 으로 저장 시 마지막으로 추가되며, 이후에만 접근하여 지정 가능. (그래야 별도 테이블에서 관리할 수 있고 다른 컨텐츠 종속값 수정 없이 순서만 변경 가능할듯.))
    const showMainTopFixManageGuide = ref(false)    // 가이드 문구 추가
    const showMainTopFixManage = ref(false)
    const mainTopFixManage = {
      close: rs => {
        showMainTopFixManage.value = false
        // if (rs) {
        //    pushToast('success', '우선순위 설정 완료')
        // }
      },
    }

    // 관심컨텐츠 유형 지정
    const showInterestContentSelect = ref(false)
    const interestContentSelect = {
      close: rs => {
        showInterestContentSelect.value = false
        if (rs && rs.length > 0) {
          liveinfo.value.interestContentIds = rs.map(x => x.id).join(',')
          liveinfo.value.interestContentTitles = rs.map(x => x.title).join(', ')
        }
      },
    }

    const resetInterestContent = () => {
      liveinfo.value.interestContentIds = null
      liveinfo.value.interestContentTitles = null
    }

    // 노출 조건 변경 시 비활성화 값 삭제
    const changeCondSetType = val => {
      if (val === '11') { // 진료과/지역별 사용자(11)
        liveinfo.value.targetGroupId = null
        liveinfo.value.targetGroupTitle = null

        // 진료과/지역별 사용자 선택 시 전체가 아닌 null 값으로 초기화 요청 (김연수M)
        liveinfo.value.condDeptCodes = null
        liveinfo.value.condDeptNames = null
        liveinfo.value.condRegionCodes = null
        liveinfo.value.condRegionNames = null
      } else { // 타겟그룹(21)
        // 환자타입조회 ON 상태에서 타겟그룹 선택 막음
        if (liveinfo.value.isPatientType) {
          liveinfo.value.condSetType = '11' // 타겟그룹 선택 되돌리기
          bvModal.msgBoxOk('\'환자 타입 조회\'가 설정되었으므로 노출 대상을 \'타겟그룹\'으로 설정할 수 없습니다.\n설정을 다시 확인해 주세요.', {
            okTitle: '확인',
          })
          refs.condSetTypeFormRules.reset()
          return
        }

        liveinfo.value.condDeptCodes = '0'
        liveinfo.value.condDeptNames = '전체 진료과'
        liveinfo.value.condRegionCodes = '0'
        liveinfo.value.condRegionNames = '전체 지역'
      }

      refs.condSetTypeFormRules.reset()
    }

    // 타겟그룹 사용 중에 환자타입조회 설정X
    const changePatientType = val => {
      if (val && liveinfo.value.condSetType !== '11' && liveinfo.value.condSetType !== 11) {
        liveinfo.value.isPatientType = false
        bvModal.msgBoxOk('노출 대상이 \'타겟그룹\'으로 설정되었으므로 \'환자 타입 조회\'를 설정할 수 없습니다.\n설정을 다시 확인해 주세요.', {
          okTitle: '확인',
        })
      } else if (val && !liveinfo.value.patientType) {
        liveinfo.value.patientType = { periods: [initPatientTypePeriod()], conds: [] }
        savedPeriodDates.value = []
      }
    }

    // 환자 타입 조회 (약품정보 전용)
    const initPatientTypePeriod = () => ({
      id: null,
      screeningStartDate: null,
      screeningEndDate: null,
      popupStartDate: null,
      popupEndDate: null,
      dataStartDate: null,
      dataEndDate: null,
    })
    const showPatientTypeSelect = ref(false)
    const savedPeriodDates = ref([])
    const toDate = v => (v ? v.toString().split('T')[0] : null)

    const patientTypeScreeningPeriodSet = computed(() =>
      (liveinfo.value.patientType?.periods || []).map(p => ({ startDate: p.screeningStartDate, endDate: p.screeningEndDate }))
    )
    const patientTypePopupPeriodSet = computed(() =>
      (liveinfo.value.patientType?.periods || []).map(p => ({ startDate: p.popupStartDate, endDate: p.popupEndDate }))
    )
    const isPatientTypeStarted = computed(() => {
      const d = savedPeriodDates.value[0]?.screeningStart
      return !!d && today >= d
    })
    const isPatientTypePeriodDisabled = (rIdx, type) => {
      const s = savedPeriodDates.value[rIdx]
      if (!s) return false
      if (type === 'screening-start') return !!s.screeningStart && today >= s.screeningStart
      if (type === 'screening-end')   return !!s.screeningEnd   && today >  s.screeningEnd
      if (type === 'popup-start')     return !!s.popupStart     && today >= s.popupStart
      if (type === 'popup-end')       return !!s.popupEnd       && today >  s.popupEnd
      if (type === 'data')            return !!s.screeningStart && today >= s.screeningStart
      return false
    }
    const addPatientTypePeriod = () => { liveinfo.value.patientType.periods.push(initPatientTypePeriod()) }
    const isRoundDeleteDisabled = rIdx => {
      const s = savedPeriodDates.value[rIdx]
      return !!s?.screeningStart && today >= s.screeningStart
    }
    const removePatientTypePeriod = (rIdx = null) => {
      const isReset = rIdx === null
      const h = instance.proxy.$createElement
      const message = isReset
        ? h('div', [
            h('p', { class: 'mb-50' }, [
              '캠페인 진행 중에 회차를 삭제하면 해당 캠페인의 ',
              h('span', { class: 'text-danger font-weight-bold' }, '수집된 데이터가 전체 초기화'),
              '되며, ',
              h('span', { class: 'text-danger font-weight-bold' }, '1회차부터 다시 진행'),
              '해야합니다.',
            ]),
            h('p', { class: 'mb-0' }, '그래도 삭제 하시겠습니까?'),
          ])
        : '삭제 하시겠습니까?'
      bvModal.msgBoxConfirm(message, {
        size: 'sm', cancelVariant: 'outline-secondary', centered: true, okTitle: '확인', cancelTitle: '취소',
      }).then(ok => {
        if (!ok) return
        if (isReset) {
          liveinfo.value.patientType = { periods: [initPatientTypePeriod()], conds: liveinfo.value.patientType?.conds || [] }
          savedPeriodDates.value = []
        } else {
          liveinfo.value.patientType.periods.splice(rIdx, 1)
          savedPeriodDates.value.splice(rIdx, 1)
        }
      })
    }
    const parsePatientTypeLabels = labels => {
      if (!labels) return []
      return labels.match(/\[[^\]]+\]/g) || []
    }
    const patientTypeSelectCond = ref(null)
    let _patientTypeEditingIdx = null
    const patientTypeSelect = {
      open(idx = null) {
        _patientTypeEditingIdx = idx
        patientTypeSelectCond.value = idx !== null ? { ...liveinfo.value.patientType.conds[idx] } : null
        showPatientTypeSelect.value = true
      },
      close(cond) {
        showPatientTypeSelect.value = false
        if (!cond) return
        if (_patientTypeEditingIdx !== null) liveinfo.value.patientType.conds.splice(_patientTypeEditingIdx, 1, cond)
        else liveinfo.value.patientType.conds.push(cond)
      },
    }
    const removePatientTypeCond = idx => {
      bvModal.msgBoxConfirm('삭제 하시겠습니까?', {
        size: 'sm', cancelVariant: 'outline-secondary', centered: true, okTitle: '확인', cancelTitle: '취소',
      }).then(ok => { if (ok) liveinfo.value.patientType.conds.splice(idx, 1) })
    }

    const validate = () => {
      const validations = []
      validations.push(refs.liveinfoFormRules.validate())

      if (refs.liveinfoMainRules && liveinfo.value.isMainView) {
        validations.push(refs.liveinfoMainRules.validate())
      }

      if (liveinfo.value.isInfoPopUp) {
        validations.push(refs.liveinfoIsInfoPopRules.validate())
      }

      if (liveinfo.value.isLiveDi) {
        validations.push(refs.liveinfoIsLiveDiRules.validate())
      }

      if (liveinfo.value.isScheduleUse) {
        validations.push(refs.liveinfoIsScheduleRules.validate())
      }

      if (liveinfo.value.isAfterConsultPopup) {
        validations.push(refs.liveinfoIsAcpRules.validate())
      }

      if (liveinfo.value.isPatientType) {
        validations.push(refs.ptPeriodRules.validate())
      }

      Promise.all(validations).then(valids => {
        const result = valids.every(Boolean)
        if (result) {
          // 조건코드 그룹(객체배열) → 전송용 문자열 배열로 변환 (UI 상태는 보존)
          const payload = {
            ...liveinfo.value,
            condDrugCodeGroups: groupsToStrings(liveinfo.value.condDrugCodeGroups),
            condDiseaseCodeGroups: groupsToStrings(liveinfo.value.condDiseaseCodeGroups),
            condLabCodeGroups: groupsToStrings(liveinfo.value.condLabCodeGroups),
            liveDiCondDrugCodeGroups: groupsToStrings(liveinfo.value.liveDiCondDrugCodeGroups),
            liveDiCondDiseaseCodeGroups: groupsToStrings(liveinfo.value.liveDiCondDiseaseCodeGroups),
            liveDiCondLabCodeGroups: groupsToStrings(liveinfo.value.liveDiCondLabCodeGroups),
          }
          emit('callback', payload)
        } else {
          emit('callback', null)
        }
      })
    }

    const fetchLiveInfo = id => {
      resetLiveinfoData()

      if (id === null) return
      axios.get(`/fa/liveinfo/${id}`)
        .then(rs => {
          const liveInfo = rs.data
          let ipuSched = false
          let spuSched = false

          if (liveInfo.schedules && liveInfo.schedules.length) {
            for (let i = 0; i < liveInfo.schedules.length; i += 1) {
              const sched = liveInfo.schedules[i]
              if (sched.popUpType === 1) {
                ipuSched = true
              }
              if (sched.popUpType === 2) {
                spuSched = true
              }
            }
          }
          if (ipuSched === false) {
            liveInfo.schedules.push({ noticeTime: null, popUpType: 1 })
          }
          if (spuSched === false) {
            liveInfo.schedules.push({ noticeTime: null, popUpType: 2 })
          }

          liveInfo.startDate = removeUTCformat(liveInfo.startDate)
          liveInfo.endDate = removeUTCformat(liveInfo.endDate)
          liveInfo.mainStartDate = liveInfo.mainStartDate !== null ? removeUTCformat(liveInfo.mainStartDate) : null
          liveInfo.mainEndDate = liveInfo.mainEndDate !== null ? removeUTCformat(liveInfo.mainEndDate) : null
          liveInfo.ipuStartDate = liveInfo.ipuStartDate !== null ? removeUTCformat(liveInfo.ipuStartDate) : null
          liveInfo.ipuEndDate = liveInfo.ipuEndDate !== null ? removeUTCformat(liveInfo.ipuEndDate) : null
          liveInfo.spuStartDate = liveInfo.spuStartDate !== null ? removeUTCformat(liveInfo.spuStartDate) : null
          liveInfo.spuEndDate = liveInfo.spuEndDate !== null ? removeUTCformat(liveInfo.spuEndDate) : null
          liveInfo.acpStartDate = liveInfo.acpStartDate ? removeUTCformat(liveInfo.acpStartDate) : null
          liveInfo.acpEndDate = liveInfo.acpEndDate ? removeUTCformat(liveInfo.acpEndDate) : null

          liveInfo.liveDiStartDate = liveInfo.liveDiStartDate !== null ? liveInfo.liveDiStartDate : null // 시간제거X
          liveInfo.liveDiEndDate = liveInfo.liveDiEndDate !== null ? liveInfo.liveDiEndDate : null // 시간제거X

          originalLiveDiEndDate.value = liveInfo.liveDiEndDate
          originalLiveInfoEndDate.value = liveInfo.endDate

          // 조건코드 그룹(condCodeGroups) → UI 입력칸 배열로 매핑
          // usage: 1=처방팝업, 2=라이브DI / codeType: 1=청구, 2=질병, 3=검사
          // ※ liveinfo.value 대입 "이전"에 평범한 liveInfo 객체에 세팅해야 반응형으로 추적됨 (Vue2 한계)
          {
            const groups = liveInfo.condCodeGroups || []
            const pick = (usage, codeType) => {
              const arr = groups
                .filter(g => g.usage === usage && g.codeType === codeType)
                .sort((a, b) => a.groupIndex - b.groupIndex)
                .map(g => ({ code: g.codes }))
              return arr.length ? arr : [{ code: '' }]
            }
            liveInfo.condDrugCodeGroups = pick(1, 1)
            liveInfo.condDiseaseCodeGroups = pick(1, 2)
            liveInfo.condLabCodeGroups = pick(1, 3)
            liveInfo.liveDiCondDrugCodeGroups = pick(2, 1)
            liveInfo.liveDiCondDiseaseCodeGroups = pick(2, 2)
            liveInfo.liveDiCondLabCodeGroups = pick(2, 3)
          }

          // Object.assign(liveinfo.value, liveInfo)
          liveinfo.value = liveInfo

          // 진료 후 팝업 - 초기 상태 기본값 보강 (기존 데이터에 필드 없을 때) — UI 표시 순서와 일치
          if (liveinfo.value.isAfterConsultPopup == null) liveinfo.value.isAfterConsultPopup = false
          if (liveinfo.value.acpButtonText == null) liveinfo.value.acpButtonText = '상세정보 보기'
          if (liveinfo.value.acpColorType == null) liveinfo.value.acpColorType = 1
          if (liveinfo.value.acpStartHour == null) liveinfo.value.acpStartHour = 12
          if (liveinfo.value.acpEndHour == null) liveinfo.value.acpEndHour = 14
          if (liveinfo.value.acpDelaySec == null) liveinfo.value.acpDelaySec = 10
          if (liveinfo.value.acpPopCount == null) liveinfo.value.acpPopCount = 1
          syncAcpTimeRangeFromValues()

          if(liveinfo.value.targetGroup)
          {
          liveinfo.value.targetGroupTitle = liveinfo.value.targetGroup.targetGroupTitle
          }
          isStarted.value = (liveInfo.startDate <= dayjs().format('YYYY-MM-DD'))  // 게시 시작여부 (true : 시작 / false : 예정)
          isMainTopFixed.value = (liveInfo.isMainTopFix)  // 메인 게시 사용 여부

          if (liveInfo.interestContents && liveInfo.interestContents.length > 0) {
            liveinfo.value.interestContentIds = liveInfo.interestContents.map(x => x.id).join(',')
            liveinfo.value.interestContentTitles = liveInfo.interestContents.map(x => x.title).join(', ')
          }

          // patientType 세팅
          if (liveInfo.patientType) {
            liveinfo.value.patientType = {
              periods: liveInfo.patientType.periods && liveInfo.patientType.periods.length > 0 ? liveInfo.patientType.periods.map(p => ({ ...p })) : [initPatientTypePeriod()],
              conds: liveInfo.patientType.conds ? [...liveInfo.patientType.conds] : [],
            }
            savedPeriodDates.value = liveinfo.value.patientType.periods.map(p => ({
              screeningStart: toDate(p.screeningStartDate),
              screeningEnd:   toDate(p.screeningEndDate),
              popupStart:     toDate(p.popupStartDate),
              popupEnd:       toDate(p.popupEndDate),
              dataStart:      toDate(p.dataStartDate),
              dataEnd:        toDate(p.dataEndDate),
            }))
          } else {
            liveinfo.value.patientType = null
            savedPeriodDates.value = []
          }
        })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: errorFormatter(error, '데이터 조회에 실패하였습니다.'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    const removeUTCformat = date => {
      let resultDate = null
      if (date.includes('T')) {
        [resultDate] = date.split('T')
      }
      return resultDate
    }

    const restrictToNumbers = () => {
      let min = String(liveinfo.value.minAge)
      min = min.replace(/[^\d\s]/g, '')
      liveinfo.value.minAge = min

      let max = String(liveinfo.value.maxAge)
      max = max.replace(/[^\d\s]/g, '')
      liveinfo.value.maxAge = max

      if (parseInt(liveinfo.value.minAge, 10) > parseInt(liveinfo.value.maxAge, 10)) {
        liveinfo.value.minAge = liveinfo.value.maxAge
      }
      if (liveinfo.value.minAge > 120) { liveinfo.value.minAge = 120 }
      if (liveinfo.value.maxAge > 120) { liveinfo.value.maxAge = 120 }
    }
    
    return {
      getInputGroupStyle,
      liveinfo,
      addCodeGroup,
      removeCodeGroup,
      condDrugCodesModel,
      condDiseaseCodesModel,
      condLabCodesModel,
      liveDiCondDrugCodesModel,
      liveDiCondDiseaseCodesModel,
      liveDiCondLabCodesModel,
      today,
      tomorrow,
      patientTypeScreeningPeriodSet,
      patientTypePopupPeriodSet,
      showPatientTypeSelect,
      isPatientTypeStarted,
      isPatientTypePeriodDisabled,
      addPatientTypePeriod,
      isRoundDeleteDisabled,
      removePatientTypePeriod,
      parsePatientTypeLabels,
      patientTypeSelect,
      patientTypeSelectCond,
      removePatientTypeCond,
      after,
      before,
      required,
      requiredIf,
      between,
      dateBetween,
      constCodes,
      validate,
      regionSelect,
      mediDeptSelect,
      showRegionSelect,
      showMediDeptSelect,
      resetLiveinfoData,
      getSchedIdxFirstOrLast,
      restrictToNumbers,
      editorOptions,
      dateDisabled,
      isDarkMode,
      targetGroupSelect,
      showTargetGroupSelect,
      mainTopFixManage,
      showMainTopFixManageGuide,
      showMainTopFixManage,
      changeCondSetType,
      changePatientType,
      getCodeLabel,
      liveDiEndDateNextDay,
      originalLiveDiEndDate,
      originalLiveInfoEndDate,
      isStarted,
      isMainTopFixed,
      showInterestContentSelect,
      interestContentSelect,
      resetInterestContent,
      removeUTCformat,
      dayjs,
      acpTimeRangeSelected,
      onAcpTimeRangeChange,
      acpPreviewHtml,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.b-form-datepicker.form-control-sm .form-control-sm{
  line-height: 2;
}

.acp-preview-wrap {
  margin-top: 0.5rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border: 1px dashed #d8d6de;
  border-radius: 6px;
  display: flex;
  justify-content: center;
}
.acp-preview {
  width: 270px;                                                /* App BrowserSize.Width = 270 */
  border: 1px solid #808080;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  font-family: '맑은 고딕', 'Malgun Gothic', sans-serif;       /* App HeaderFont */
  overflow: hidden;
}
.acp-preview__header {                                         /* App HeaderHeight = 30 */
  height: 30px;
  padding: 0 8px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.acp-preview__header--gray {                                   /* Gray preset · 단색 (그라데이션 없음) */
  background: #5B5B5B;
  color: #FFFFFF;
}
.acp-preview__header--blue {                                   /* Blue preset · 단색 */
  background: #3F74F4;
  color: #FFFFFF;
}
.acp-preview__title {
  font-weight: normal;
}
.acp-preview__close {
  font-size: 14px;
  padding: 0 4px;
  cursor: default;
}
.acp-preview__header--gray .acp-preview__close { color: #FFFFFF; }
.acp-preview__header--blue .acp-preview__close { color: #FFFFFF; }
.acp-preview__body {                                           /* App WebBrowser 크기 = 270 x 160 */
  width: 100%;
  height: 160px;
  border: none;
  display: block;
  background-color: #ffffff;                                   /* App: BodyColor=Transparent · WebBrowser IE 기본 흰색 */
}
.acp-preview__bottom {                                         /* App BottomHeight = 30 · 단색 #333333 · 맑은 고딕 8pt */
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #FFFFFF;
  font-size: 12px;
  cursor: default;
  background: #333333;
}
</style>
